<template>
  <div class="ExamCityReports">
    <h1 class="text-center my-7">گزارش تعداد کاربران شهرستان {{ city }}</h1>
    <v-row>
      <v-col cols="12">
        <v-card class="mb-10">
          <div class="d-flex align-center justify-center py-5">
            <h4 class="ml-3">
              تعداد کل آزمون های برگزار شده در شهرستان {{ city }}
            </h4>
            <h3><number :number="count"></number></h3>
          </div>
        </v-card>
      </v-col>
      <v-col cols="12">
        <h4 class="mb-5">گزارش آزمون های برگزار شده بر اساس کتاب</h4>
      </v-col>
      <v-col cols="12" md="3">
        <v-card class="mb-10">
          <v-card-title>
            <v-text-field
              v-model="bookSearch"
              class="pa-0"
              append-icon="mdi-magnify"
              label="جستجو"
              single-line
              hide-details
            ></v-text-field>
          </v-card-title>
          <v-card-text>
            <v-data-table
              :headers="bookHeaders"
              :items="books"
              :search="bookSearch"
              :loading="loading"
              :items-per-page="5"
            >
              <template v-slot:[`item.count`]="{ item }">
                <number :number="item.count"></number>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12" md="9">
        <apex-chart
          v-if="!loading"
          ref="lineChart"
          type="line"
          height="480"
          class="mb-10"
          :options="bookChartOptions"
          :series="bookChartSeries"
        />
      </v-col>
      <v-col cols="12" class="text-center">
        <v-btn
          outlined
          depressed
          color="primary"
          router
          :to="{
            name: 'ExamStateReports',
            params: { id: this.$route.params.stateId }
          }"
        >
          بازگشت
        </v-btn>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import Number from "../../../components/Shared/Number.vue";
export default {
  components: { Number },
  name: "exam-city-reports",
  data() {
    return {
      loading: false,
      city: "",
      count: 0,
      bookHeaders: [
        { text: "نام کتاب", value: "title", align: "center" },
        { text: "مقطع", value: "grade", align: "center" },
        { text: "کتاب شماره", value: "level", align: "center" },
        { text: "تعداد آزمون برگزار شده", value: "count", align: "center" }
      ],
      books: [],
      bookSearch: "",
      bookChartSeries: [
        {
          name: "نمره کل",
          data: []
        },
        {
          name: "تمرکز",
          data: []
        },
        {
          name: "استنباط",
          data: []
        },
        {
          name: "تفسیر",
          data: []
        },
        {
          name: "ارزیابی",
          data: []
        }
      ],
      bookChartOptions: {
        chart: {
          type: "line",
          fontFamily: "dana"
        },
        title: {
          text: "میانگین نمرات آزمون های برگزار شده بر اساس کتاب",
          align: "center",
          margin: 30,
          style: {
            fontSize: "20px"
          }
        },
        markers: {
          size: 6,
          colors: "#F4A046"
        },
        fill: {
          colors: ["#ffbe0b", "#FB5607", "#FF006E", "#8338EC", "#3A86FF"]
        },
        grid: {
          row: {
            colors: ["#f3f3f3", "transparent"], // takes an array which will be repeated on columns
            opacity: 0.5
          }
        },
        xaxis: {
          categories: [],
          position: "top",
          labels: {
            rotate: -90,
            rotateAlways: true,
            minHeight: 140,
            maxHeight: 200
          }
        },
        yaxis: {
          seriesName: "تعداد شرکت کننده",
          tickAmount: 10,
          min: 0,
          max: 100
        }
      }
    };
  },
  created() {
    this.getData();
  },
  methods: {
    getData() {
      this.loading = true;
      const apiUrl = "answersheets/reportsByCity/" + this.$route.params.id;
      this.$api
        .get(apiUrl)
        .then((res) => {
          // state
          const data = res.data;
          this.city = data.city.name;
          this.count = data.count[0].count;

          // book
          data.books.forEach((element) => {
            this.bookChartSeries[0].data.push(element.totalScore.toFixed(1));
            this.bookChartSeries[1].data.push(element.focusScore.toFixed(1));
            this.bookChartSeries[2].data.push(
              element.inferenceScore.toFixed(1)
            );
            this.bookChartSeries[3].data.push(
              element.interpretationScore.toFixed(1)
            );
            this.bookChartSeries[4].data.push(
              element.assessmentScore.toFixed(1)
            );
            this.bookChartOptions.xaxis.categories.push(element.title);
          });

          this.books = data.books;
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    }
  }
};
</script>
<style>
.ExamCityReports .apexcharts-xaxis-texts-g {
  transform: translate(0, 95px);
}
.ExamCityReports .apexcharts-yaxis {
  transform: translate(-97%, 0);
}
@media only screen and (max-width: 600px) {
  .ExamCityReports .apexcharts-xaxis-texts-g {
    transform: translate(0, 95px);
  }
}
</style>
